import React, { Component } from "react";
import { connect } from "react-redux";
import ImageButton from "./ImageButton";
import icon from "../../img/update.svg";
import { installUpdate } from "../../js/auth";

class UpdateAvailable extends Component {
  render() {
    const { updateAvailable } = this.props;
    if (!updateAvailable) return null;
    return (
       <ImageButton handleClick={installUpdate} clazz="status-icon-new-blink" id="update" src={icon} style={{ width: "22px", height: "22px", }}></ImageButton>
    );
  }
}

const mapStateToProps = (props, state) => {
  if (props.rootReducer.myStatus) {
    return {
      updateAvailable: props.rootReducer.updateAvailable
    };
  }
  return {};
};
export default connect(mapStateToProps)(UpdateAvailable);

